import { render, staticRenderFns } from "./StepVertical.vue?vue&type=template&id=689ee1a8&"
import script from "./StepVertical.vue?vue&type=script&lang=js&"
export * from "./StepVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports